// /src/data/hero-data.ts
import type { Language } from "@/lib/i18n";

interface HeroSlide {
  id: number;
  type: "video" | "image";
  src: string;
  title: string;
  subtitle: string;
  poster?: string;
  cta: { text: string; link: string } | null;
}

interface HeroData {
  slides: HeroSlide[];
}

const heroDataByLang: Record<Language, HeroData> = {
  id: {
    slides: [
      {
        id: 1,
        type: "video",
        src: "/videos/hero-slide-1.webm",
        title: "KinKen Kost Elite",
        subtitle: "Pengalaman Co-Living Mewah Terbaik di Bali",
        cta: {
          text: "Pesan Sekarang",
          link: "/rooms",
        },
      },
      {
        id: 2,
        type: "video",
        src: "/videos/hero-slide-2.webm",
        title: "Sanctuary Ketenangan",
        subtitle: "Oasis pribadi Anda di jantung Denpasar",
        cta: null,
      },
      {
        id: 3,
        type: "video",
        src: "/videos/hero-slide-3.webm",
        title: "Standar Hidup Terbaik",
        subtitle: "Dirancang untuk profesional modern & ekspatriat",
        cta: null,
      },
    ],
  },
  en: {
    slides: [
      {
        id: 1,
        type: "video",
        src: "/videos/hero-slide-1.webm",
        title: "KinKen Kost Elite",
        subtitle: "Bali's Premier Luxury Co-Living Experience",
        cta: {
          text: "Book Your Stay",
          link: "/rooms",
        },
      },
      {
        id: 2,
        type: "video",
        src: "/videos/hero-slide-2.webm",
        title: "Sanctuary of Serenity",
        subtitle: "Your private oasis in vibrant Denpasar",
        cta: null,
      },
      {
        id: 3,
        type: "video",
        src: "/videos/hero-slide-3.webm",
        title: "Elevated Living Standards",
        subtitle: "Designed for modern professionals & expatriates",
        cta: null,
      },
    ],
  },
};

// Backward compatibility - default export
export const HERO_DATA = heroDataByLang.id;

// New function for i18n support
export function getHeroData(lang: Language = "id"): HeroData {
  return heroDataByLang[lang] || heroDataByLang.id;
}
